module.exports = __webpack_public_path__ + "static/media/Universal_Payment.af8cc9ed.svg";